/**
 * Sort filter options by presence first (present items first), then alphabetically.
 */
export function sortFilterOptionsByPresence<
  T extends { value: string; present?: boolean },
>(items: T[]): T[] {
  return [...items].sort((a, b) => {
    const aPresent = a.present ?? true;
    const bPresent = b.present ?? true;
    if (aPresent && !bPresent) return -1;
    if (!aPresent && bPresent) return 1;
    return a.value.localeCompare(b.value);
  });
}

/** Border + shadow styling shared by all chart-filter dropdown panels. */
export const FILTER_DROPDOWN_PANEL_CLASS =
  "border border-[var(--color-border)] dark:border-[var(--color-border)] shadow-[0px_10px_20px_0px_rgba(0,0,0,0.12)] dark:shadow-[0px_10px_20px_0px_rgba(0,0,0,0.2)]";

/** Used for list-based filter panels (repos, branches, workflows, etc.) that need a minimum width for react-window. */
export const FILTER_PANEL_WIDE_CLASS =
  "min-w-[300px] max-w-[500px] overflow-visible rounded-lg bg-white dark:bg-[#2A2C2C] p-0";

/** Used for the status filter panel which has no virtualized list and can shrink to fit its content. */
export const FILTER_PANEL_STATUS_CLASS =
  "w-fit max-w-[500px] overflow-visible rounded-lg bg-white dark:bg-[#2A2C2C] p-0";

/** `"acme/web"` → `"web"` */
export const repoNameWithoutOrgPrefix = (repo: string) => {
  if (!repo) return "";
  return repo.split("/").pop() ?? "";
};

/** `("acme", "web")` → `"acme/web"` */
export const repoNameWithOrgPrefix = (org: string | null, repo: string) => {
  return org && !repo.startsWith(`${org}/`) ? `${org}/${repo}` : repo;
};
